var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{ref:"topData",attrs:{"disabled":_vm.operateType === 'issue'
      ? !_vm.canEdit || _vm.formData.statusFlag !== '004'
      : ['002', '004', '005', '006', '007', '008'].indexOf(_vm.formData.statusFlag) != -1 || !_vm.canEdit,"options":_vm.options,"rules":_vm.rules,"label-width":"100px"},on:{"input":_vm.handleChange},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }